import styles from "./pageContentWrapper.module.scss";

export default function PageContentWrapper(props: { children: React.ReactNode }) {
  return <div className={styles.pageContentWrapper}>
    <div className={styles.pageContent}>
      {props.children}
    </div>
  </div>
}
